import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthenticationService } from '../../services/authentication.service';
import ToastService from '../../services/toast.service';
import logger from '../../utils/logger';

function PrivateRoute({ roles, children }) {
  const auth = useAuthenticationService();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function checkAuthentication() {
      try {
        setLoading(true);
        await auth.initializeSession();
        const refreshSuccess = await auth.refreshToken();
        const authenticated = refreshSuccess && auth.isAuthenticated();

        if (!authenticated && isMounted) {
          setIsAuthenticated(false);
          setLoading(false);
          return;
        }

        if (isMounted) {
          setIsAuthenticated(authenticated);
          const authorized = authenticated && (!roles || roles.length === 0 || auth.isInAnyRole(roles));
          setIsAuthorized(authorized);
          
          if (authenticated && !authorized) {
            ToastService.warn('You are not authorized to view this page', 'privateroute', {
              closeOnClick: false
            });
            window.history.back();
          }
          setLoading(false);
        }
      } catch (error) {
        logger.error('Authentication check failed:', error);
        if (isMounted) {
          setIsAuthenticated(false);
          setLoading(false);
        }
      }
    }

    checkAuthentication();

    return () => {
      isMounted = false;
    };
  }, [auth, roles]);

  if (loading) {
    logger.log('Loading...');
    return null; // Render nothing while checking authentication
  }

  if (!isAuthenticated) {
    logger.log('Navigate to login');
    return <Navigate to='/login' />;
  }

  if (!isAuthorized) {
    logger.log('Not authorized');
    return null;
  }
  return children;
}

export default PrivateRoute;
